
export const LEGACY_CLIENT_RIGHTS = [
    {
        'name': 'user-roles',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'access-groups',
        'title': 'Cost Centres',
        'description': 'Rights relating to cost centre management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete cost centres',
            },
        ],
    },
    {
        'name': 'asset-categories',
        'title': 'Asset Categories',
        'description': 'Rights relating to asset category management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete asset categories',
            },
        ],
    },
    {
        'name': 'assets-groups',
        'title': 'Asset Groups',
        'description': 'Rights relating to asset group management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete asset groups',
            },
        ],
    },
    {
        'name': 'assets',
        'title': 'Assets',
        'description': 'Rights relating to asset management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the assets in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete assets',
            },
        ],
    },
    {
        'name': 'devices',
        'title': 'Devices',
        'description': 'Rights relating to device management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the devices in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'description': 'Upload parameters to devices',
            },
        ],
    },
    {
        'name': 'simcards',
        'title': 'SIM Cards',
        'description': 'Rights relating to SIM card management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the SIM cards in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete SIM cards',
            },
        ],
    },
    {
        'name': 'fuelcards',
        'title': 'Fuel Cards',
        'description': 'Rights relating to fuel card management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the fuel cards in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete fuel cards',
            },
        ],
    },
    {
        'name': 'deviceProviders',
        'title': 'Device Providers',
        'description': 'Rights relating to device provider management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the device providers in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete device providers',
            },
        ],
    },
    {
        'name': 'smsGatewayProviders',
        'title': 'SMS Gateways',
        'description': 'Rights relating to SMS gateway management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the SMS gateways in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete SMS gateways',
            },
        ],
    },
    {
        'name': 'emailProviders',
        'title': 'Email Providers',
        'description': 'Rights relating to email provider management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the email providers in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete email providers',
            },
        ],
    },
    {
        'name': 'zones',
        'title': 'Zones',
        'description': 'Rights relating to zone management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the zones in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete zones and their groups',
            },
        ],
    },
    {
        'name': 'alerts',
        'title': 'Alerts',
        'description': 'Rights relating to alert management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the alerts in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete alert definitions',
            },
        ],
    },
    {
        'name': 'media',
        'title': 'Media',
        'description': 'Rights relating to viewing and generating media events',
        'rights': [
            {
                'title': 'View',
                'name': 'view',
                'description': 'View and list videos and images',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create media requests',
            },
            {
                'title': 'Update',
                'name': 'update',
                'description': 'Modify media requests',
            },
        ],
    },
    {
        'name': 'analytics',
        'title': 'Analytics',
        'description': 'Rights relating to analytics reports',
        'rights': [
            {
                'title': 'View',
                'name': 'view',
                'description': 'View analytics reports',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'reports',
        'title': 'Reports',
        'description': 'Rights relating to reports',
        'rights': [
            {
                'title': 'Run',
                'name': 'run',
                'description': 'Run reports on demand.',
            },
            {
                'title': 'Schedule',
                'name': 'schedule',
                'description': 'Create, modify and delete scheduled reports',
            },
            {
                'title': 'Templates',
                'name': 'templates',
                'description': 'Create, modify and delete report templates',
            },
        ],
    },
    {
        'name': 'customFields',
        'title': 'Custom Fields',
        'description': 'Rights relating to custom fields',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete custom fields.',
            },
        ],
    },
];


export const LEGACY_VENDOR_RIGHTS = [
    {
        'name': 'clients',
        'title': 'Clients',
        'description': 'Rights relating to client management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the clients in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete clients',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'description': 'List client users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'description': 'Create, modify and delete client users and their roles',
            },
            {
                'title': 'List Assets',
                'name': 'list-assets',
                'description': 'List client assets',
            },
            {
                'title': 'Modify Assets',
                'name': 'assets',
                'description': 'Create, modify and delete assets and their groups',
            },
            {
                'title': 'List Devices',
                'name': 'list-devices',
                'description': 'List client devices',
            },
            {
                'title': 'Modify Devices',
                'name': 'devices',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'List SIM Cards',
                'name': 'list-simcards',
                'description': 'List SIM cards',
            },
            {
                'title': 'Modify SIM Cards',
                'name': 'simcards',
                'description': 'Create, modify and delete SIM cards',
            },
            {
                'title': 'List Fuel Cards',
                'name': 'list-fuelcards',
                'description': 'List fuel cards',
            },
            {
                'title': 'Modify Fuel Cards',
                'name': 'fuelcards',
                'description': 'Create, modify and delete fuel cards',
            },
            {
                'title': 'List Device Providers',
                'name': 'list-deviceProviders',
                'description': 'List client device providers',
            },
            {
                'title': 'Modify Device Providers',
                'name': 'deviceProviders',
                'description': 'Create, modify and delete device providers',
            },
            {
                'title': 'List SMS Gateways',
                'name': 'list-smsGatewayProviders',
                'description': 'List client SMS gateways',
            },
            {
                'title': 'Modify SMS Gateways',
                'name': 'smsGatewayProviders',
                'description': 'Create, modify and delete SMS gateways',
            },
            {
                'title': 'List Email Providers',
                'name': 'list-emailProviders',
                'description': 'List client email providers',
            },
            {
                'title': 'Modify Email Providers',
                'name': 'emailProviders',
                'description': 'Create, modify and delete email providers',
            },
            {
                'title': 'List Zones',
                'name': 'list-zones',
                'description': 'List client zones',
            },
            {
                'title': 'Modify Zones',
                'name': 'zones',
                'description': 'Create, modify and delete zones and their groups',
            },
            {
                'title': 'View Media',
                'name': 'list-media',
                'description': 'View client media',
            },
            {
                'title': 'Modify Media',
                'name': 'media',
                'description': 'Request media and update media events',
            },
            {
                'title': 'Modify Alerts',
                'name': 'alerts',
                'description': 'Create, modify and delete alert definitions',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'description': 'Upload parameters to devices',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Run Reports',
                'name': 'reports',
                'description': 'Run and schedule reports',
            },
            {
                'title': 'Modify Report Templates',
                'name': 'report-templates',
                'description': 'Create, modify and delete report templates',
            },
            {
                'title': 'Custom Fields',
                'name': 'customFields',
                'description': 'Create, modify and delete custom fields',
            },
            {
                'title': 'Analytics Reports',
                'name': 'analytics',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'user-roles',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'themes',
        'title': 'Themes',
        'description': 'Rights relating to theme management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete themes',
            },
        ],
    },
    {
        'name': 'mapSets',
        'title': 'Map Sets',
        'description': 'Rights relating to map set management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete map sets',
            },
        ],
    },
    {
        'name': 'billing',
        'title': 'Billing',
        'description': 'Rights relating to billing profiles',
        'rights': [
            {
                'title': 'Create Profiles',
                'name': 'createProfile',
                'description': 'Create, modify and delete billing profiles',
            },
        ],
    },
];

export const LEGACY_DISTRIBUTOR_RIGHTS = [
    {
        'name': 'vendors',
        'title': 'Vendors',
        'description': 'Rights relating to vendor management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the vendors in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete vendors',
            },
            {
                'title': 'Migrate',
                'name': 'migrate',
                'description': 'Migrate vendors between distributors',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'description': 'List vendor users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'description': 'Create, modify and delete vendor users',
            },
        ],
    },
    {
        'name': 'clients',
        'title': 'Clients',
        'description': 'Rights relating to client management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the clients in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete clients',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'description': 'List client users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'description': 'Create, modify and delete client users and their roles',
            },
            {
                'title': 'List Assets',
                'name': 'list-assets',
                'description': 'List client assets',
            },
            {
                'title': 'Modify Assets',
                'name': 'assets',
                'description': 'Create, modify and delete assets and their groups',
            },
            {
                'title': 'List Devices',
                'name': 'list-devices',
                'description': 'List client devices',
            },
            {
                'title': 'Modify Devices',
                'name': 'devices',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'List SIM Cards',
                'name': 'list-simcards',
                'description': 'List SIM cards',
            },
            {
                'title': 'Modify SIM Cards',
                'name': 'simcards',
                'description': 'Create, modify and delete SIM cards',
            },
            {
                'title': 'List Fuel Cards',
                'name': 'list-fuelcards',
                'description': 'List fuel cards',
            },
            {
                'title': 'Modify Fuel Cards',
                'name': 'fuelcards',
                'description': 'Create, modify and delete fuel cards',
            },
            {
                'title': 'List Device Providers',
                'name': 'list-deviceProviders',
                'description': 'List client device providers',
            },
            {
                'title': 'Modify Device Providers',
                'name': 'deviceProviders',
                'description': 'Create, modify and delete device providers',
            },
            {
                'title': 'List SMS Gateways',
                'name': 'list-smsGatewayProviders',
                'description': 'List client SMS gateways',
            },
            {
                'title': 'Modify SMS Gateways',
                'name': 'smsGatewayProviders',
                'description': 'Create, modify and delete SMS gateways',
            },
            {
                'title': 'List Email Providers',
                'name': 'list-emailProviders',
                'description': 'List client email providers',
            },
            {
                'title': 'Modify Email Providers',
                'name': 'emailProviders',
                'description': 'Create, modify and delete email providers',
            },
            {
                'title': 'List Zones',
                'name': 'list-zones',
                'description': 'List client zones',
            },
            {
                'title': 'Modify Zones',
                'name': 'zones',
                'description': 'Create, modify and delete zones and their groups',
            },
            {
                'title': 'View Media',
                'name': 'list-media',
                'description': 'View client media',
            },
            {
                'title': 'Modify Media',
                'name': 'media',
                'description': 'Request media and update media events',
            },
            {
                'title': 'Modify Alerts',
                'name': 'alerts',
                'description': 'Create, modify and delete alert definitions',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'description': 'Upload parameters to devices',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Run Reports',
                'name': 'reports',
                'description': 'Run and schedule reports',
            },
            {
                'title': 'Modify Report Templates',
                'name': 'report-templates',
                'description': 'Create, modify and delete report templates',
            },
            {
                'title': 'Custom Fields',
                'name': 'customFields',
                'description': 'Create, modify and delete custom fields',
            },
            {
                'title': 'Analytics Reports',
                'name': 'analytics',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'user-roles',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'themes',
        'title': 'Themes',
        'description': 'Rights relating to theme management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete themes',
            },
        ],
    },
    {
        'name': 'mapSets',
        'title': 'Map Sets',
        'description': 'Rights relating to map set management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete map sets',
            },
        ],
    },
    {
        'name': 'billing',
        'title': 'Billing',
        'description': 'Rights relating to billing profiles',
        'rights': [
            {
                'title': 'Create Profiles',
                'name': 'createProfile',
                'description': 'Create, modify and delete billing profiles',
            },
        ],
    },
];

export const LEGACY_SYSTEM_RIGHTS = [
    {
        'name': 'system',
        'title': 'System',
        'description': 'Rights relating to system management',
        'rights': [
            {
                'title': 'Global Lookups',
                'name': 'global-lookups',
                'description': 'Create, modify and delete global lookups',
            },
        ],
    },
    {
        'name': 'distributors',
        'title': 'Distributors',
        'description': 'Rights relating to distributor management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the distributors in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete distributors',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'description': 'List distributor users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'description': 'Create, modify and delete distributor users',
            },
        ],
    },
    {
        'name': 'vendors',
        'title': 'Vendors',
        'description': 'Rights relating to vendor management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the vendors in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete vendors',
            },
            {
                'title': 'Migrate',
                'name': 'migrate',
                'description': 'Migrate vendors between distributors',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'description': 'List vendor users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'description': 'Create, modify and delete vendor users',
            },
        ],
    },
    {
        'name': 'clients',
        'title': 'Clients',
        'description': 'Rights relating to client management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the clients in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete clients',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'description': 'List client users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'description': 'Create, modify and delete client users and their roles',
            },
            {
                'title': 'List Assets',
                'name': 'list-assets',
                'description': 'List client assets',
            },
            {
                'title': 'Modify Assets',
                'name': 'assets',
                'description': 'Create, modify and delete assets and their groups',
            },
            {
                'title': 'List Devices',
                'name': 'list-devices',
                'description': 'List client devices',
            },
            {
                'title': 'Modify Devices',
                'name': 'devices',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'List SIM Cards',
                'name': 'list-simcards',
                'description': 'List SIM cards',
            },
            {
                'title': 'Modify SIM Cards',
                'name': 'simcards',
                'description': 'Create, modify and delete SIM cards',
            },
            {
                'title': 'List Fuel Cards',
                'name': 'list-fuelcards',
                'description': 'List fuel cards',
            },
            {
                'title': 'Modify Fuel Cards',
                'name': 'fuelcards',
                'description': 'Create, modify and delete fuel cards',
            },
            {
                'title': 'List Device Providers',
                'name': 'list-deviceProviders',
                'description': 'List client device providers',
            },
            {
                'title': 'Modify Device Providers',
                'name': 'deviceProviders',
                'description': 'Create, modify and delete device providers',
            },
            {
                'title': 'List SMS Gateways',
                'name': 'list-smsGatewayProviders',
                'description': 'List client SMS gateways',
            },
            {
                'title': 'Modify SMS Gateways',
                'name': 'smsGatewayProviders',
                'description': 'Create, modify and delete SMS gateways',
            },
            {
                'title': 'List Email Providers',
                'name': 'list-emailProviders',
                'description': 'List client email providers',
            },
            {
                'title': 'Modify Email Providers',
                'name': 'emailProviders',
                'description': 'Create, modify and delete email providers',
            },
            {
                'title': 'List Zones',
                'name': 'list-zones',
                'description': 'List client zones',
            },
            {
                'title': 'Modify Zones',
                'name': 'zones',
                'description': 'Create, modify and delete zones and their groups',
            },
            {
                'title': 'View Media',
                'name': 'list-media',
                'description': 'View client media',
            },
            {
                'title': 'Modify Media',
                'name': 'media',
                'description': 'Request media and update media events',
            },
            {
                'title': 'Modify Alerts',
                'name': 'alerts',
                'description': 'Create, modify and delete alert definitions',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'description': 'Upload parameters to devices',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Run Reports',
                'name': 'reports',
                'description': 'Run and schedule reports',
            },
            {
                'title': 'Modify Report Templates',
                'name': 'report-templates',
                'description': 'Create, modify and delete report templates',
            },
            {
                'title': 'Custom Fields',
                'name': 'customFields',
                'description': 'Create, modify and delete custom fields',
            },
            {
                'title': 'Analytics Reports',
                'name': 'analytics',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'user-roles',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'themes',
        'title': 'Themes',
        'description': 'Rights relating to theme management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete themes',
            },
        ],
    },
    {
        'name': 'mapSets',
        'title': 'Map Sets',
        'description': 'Rights relating to map set management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'description': 'Create, modify and delete map sets',
            },
        ],
    },
    {
        'name': 'billing',
        'title': 'Billing',
        'description': 'Rights relating to billing profiles',
        'rights': [
            {
                'title': 'Create Profiles',
                'name': 'createProfile',
                'description': 'Create, modify and delete billing profiles',
            },
        ],
    },
];

export const LEGACY_RIGHTS = {
    system: LEGACY_SYSTEM_RIGHTS,
    distributor: LEGACY_DISTRIBUTOR_RIGHTS,
    vendor: LEGACY_VENDOR_RIGHTS,
    client: LEGACY_CLIENT_RIGHTS,
};
